var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import EditSvg from './edit-03.icon.svg';
export const EditIcon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: EditSvg }));
_react_refresh_temp_1 = EditIcon;
$RefreshReg$(_react_refresh_temp_1, "EditIcon");
